'use client';

import React from 'react';
import { BuilderBlocks, BuilderElement } from '@builder.io/react';
import Link from 'next/link';
import Image from '@/components/ui/Image';
import { PageContext } from '../builder';
import { cn } from '@/lib/utils';

interface FormSectionProps {
  combinedLogo?: string;
  headerBackgroundColour?: string;
  leftColumn: BuilderElement[];  
  rightColumn: BuilderElement[];  
  withRightColumn: boolean;
  builderBlock: BuilderElement;
  attributes?: React.HTMLProps<HTMLElement>;
}

export const FormSection = ({ leftColumn, rightColumn, withRightColumn, builderBlock, combinedLogo, headerBackgroundColour }: FormSectionProps) => {
  const pageFields = React.useContext(PageContext);
  const { logo } = pageFields.data as unknown as { logo: { url: string; src: string; darkSrc: string; alt: string } };

  return (
    <div 
      className="flex bg-position-[25%_22px] lg:bg-position-[75%_22px] min-h-screen"  
      // style={{
      //   backgroundImage: "url('/background-graph.svg')",
      //   backgroundSize: "auto",
      //   backgroundRepeat: "no-repeat",
      //   // backgroundAttachment: "fixed",
      // }}
    >
      {/* Left Column - Form */}
      <div className="flex-1 flex flex-col">
        {/* <div className="w-full h-[72px] px-4 lg:px-8 flex items-center sticky top-0 bg-background z-10"> */}
        <div className={cn("w-full h-[72px] px-4 lg:px-8 flex items-center bg-background z-10 justify-between")} style={{ backgroundColor: headerBackgroundColour ? headerBackgroundColour : "" }}>
          {/* Logo */}
          {combinedLogo ? (
            <div className="h-[30px]">
              <Image
                src={combinedLogo}
                alt={combinedLogo}
                width={0}
                height={30}
                loading="eager"
                priority
                className="theme-logo h-[30px] w-auto"
              />
            </div>
          ) : (
            <div className="w-[90px]">
              <Link href="/">
                <Image
                  src={logo.src}
                  data-src-dark={logo.darkSrc}
                  data-theme-logo
                  alt={logo.alt}
                  width={90}
                  height={30}
                  loading="eager"
                  priority
                  className="theme-logo"
                />
              </Link>
            </div>
          )}
          <p className="paragraph-sm hidden lg:flex items-center gap-2">
            <span>Have a general enquiry?</span>
            <Link href="/contact-us" className="underline">Contact us</Link>
          </p>
        </div>
        <div className="flex-1 flex items-center justify-center px-4 lg:px-8 pt-8 pb-14 lg:py-20">
          <BuilderBlocks
            parentElementId={builderBlock?.id}
            dataPath="leftColumn"
            blocks={leftColumn ?? []}
            className="flex flex-1"
          />  
        </div>
        <div className="w-full p-8 flex items-center justify-between flex-col md:flex-row gap-6 text-foreground">
          <div className="flex flex-col md:flex-row gap-2 md:gap-1 items-center justify-center max-w-[600px]">
            <p className="paragraph-sm">© 2008 – {new Date().getFullYear()} Octet Finance.</p>
            <p className="paragraph-sm">All Rights Reserved.</p> 
          </div>
          <div className="flex flex-row gap-2 items-center justify-center md:justify-end flex-1 text-muted-foreground pr-16">
            <Link href="/legal/privacy-policy" target="_blank" className="paragraph-sm">
              Privacy Policy
            </Link>
            <span className="paragraph-sm">|</span>
            <Link href="/legal/conditions-of-use" target="_blank" className="paragraph-sm">
              Terms and Conditions
            </Link> 
          </div>
        </div>
      </div>
      
      {/* Right Column - Builder Content */}
      {withRightColumn && (
        <div className="w-1/4 min-w-[500px] bg-background hidden lg:block dark">
          <div className="flex justify-center items-center h-full" >
            <BuilderBlocks
              parentElementId={builderBlock?.id}
              dataPath="rightColumn"
              blocks={rightColumn ?? []}
              className="w-full "
            />  
          </div>
        </div>
      )}
    </div>
  );
}; 